import { apiGateway } from '../api';

async function getRedirectUrls(codContrato) {
    try {
        const response = await apiGateway.post('/gerar-url', { codContrato });

        return response.data;
    } catch (error) {
        return {};
    }
}

async function getGruposContratoAndContratosByEmail(email) {
    try {
        const params = new URLSearchParams();
        params.append('email', email);

        const response = await apiGateway.get('/grupos-contrato/contratos', { params });
        return response.data;
    } catch (error) {
        return [];
    }
}

async function getGruposContratoAndContratosByContractNumber(numContrato) {
    try {
        const params = new URLSearchParams();
        params.append('numContrato', numContrato);

        const response = await apiGateway.get('/grupos-contrato/contratos', { params });
        return response.data;
    } catch (error) {
        return error;
    }
}

async function getDadosContratosContato(numContrato, email) {
    try {
        const params = new URLSearchParams();
        params.append('email', email);
        params.append('numContrato', numContrato);

        const response = await apiGateway.get('/contratos/contatos', { params });
        return response.data;
    } catch (error) {
        return error;
    }
}

async function getGruposContratoAndContratosByCpfCnpj(cpfCnpj) {
    try {
        const params = new URLSearchParams();
        params.append('cpfCnpj', cpfCnpj);

        const response = await apiGateway.get('/grupos-contrato/contratos', { params });
        return response.data;
    } catch (error) {
        return error;
    }
}

export {
    getGruposContratoAndContratosByEmail,
    getDadosContratosContato,
    getGruposContratoAndContratosByContractNumber,
    getGruposContratoAndContratosByCpfCnpj,
    getRedirectUrls,
};
